var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-container',{staticClass:"bv-example-row mt-5"},[_c('b-row',_vm._l((_vm.Electronics),function(product){return _c('ProductCard',{key:product.id,attrs:{"product":product}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }